/* Arcana — compact nav on scroll + scroll progress bar
   Shadow-only compact state (no header height changes) to avoid fighting
   Dawn sticky-header hide/reveal (on-scroll-up).
*/
(function () {
  'use strict';

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const COMPACT_ON = 120;
  const COMPACT_OFF = 48;
  let ticking = false;
  let isCompact = false;

  const ensureBar = () => {
    if (document.getElementById('arcana-progress-bar')) return;
    const bar = document.createElement('div');
    bar.id = 'arcana-progress-bar';
    document.body.appendChild(bar);
  };
  ensureBar();
  const bar = document.getElementById('arcana-progress-bar');

  const headerSection = () => document.querySelector('.section-header');

  const headerIsHidden = () => {
    const section = headerSection();
    return section?.classList.contains('shopify-section-header-hidden') ?? false;
  };

  const syncHeaderHeight = () => {
    const section = headerSection();
    if (!section) return;
    document.documentElement.style.setProperty('--header-height', `${section.offsetHeight}px`);
  };

  const setCompact = (next) => {
    if (next === isCompact) return;
    isCompact = next;
    if (!reduceMotion) {
      document.body.classList.toggle('arcana-nav-compact', isCompact);
    }
    requestAnimationFrame(syncHeaderHeight);
  };

  const update = () => {
    const y = window.scrollY;

    if (!reduceMotion && !headerIsHidden()) {
      let nextCompact = isCompact;
      if (y >= COMPACT_ON) {
        nextCompact = true;
      } else if (y <= COMPACT_OFF) {
        nextCompact = false;
      }
      setCompact(nextCompact);
    } else if (isCompact) {
      setCompact(false);
    }

    if (bar) {
      const max = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
      const pct = Math.min(100, (y / max) * 100);
      bar.style.setProperty('--arcana-progress', pct + '%');
    }

    ticking = false;
  };

  const onScroll = () => {
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  };

  const observeHeader = () => {
    const section = headerSection();
    if (!section || typeof MutationObserver === 'undefined') return null;

    const observer = new MutationObserver(() => {
      if (headerIsHidden() && isCompact) {
        setCompact(false);
      }
      requestAnimationFrame(syncHeaderHeight);
    });

    observer.observe(section, { attributes: true, attributeFilter: ['class'] });
    return observer;
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  const headerObserver = observeHeader();
  update();

  // Clean up listeners/observer on unload (also covers bfcache).
  window.addEventListener('pagehide', function teardown() {
    window.removeEventListener('scroll', onScroll);
    window.removeEventListener('resize', onScroll);
    if (headerObserver) headerObserver.disconnect();
    window.removeEventListener('pagehide', teardown);
  });
})();
